/**
 * Get Product By Slug Use Case
 * 
 * Application use case for retrieving a product by its slug.
 */

import { IProductService } from '@/domain/services/product.service.interface';
import { ProductEntity } from '@/domain/entities/product.entity';

export interface GetProductBySlugInput {
  slug: string;
}

export interface GetProductBySlugOutput {
  product: ProductEntity | null;
}

export class GetProductBySlugUseCase {
  constructor(private readonly productService: IProductService) {}

  async execute(input: GetProductBySlugInput): Promise<GetProductBySlugOutput> {
    if (!input.slug || input.slug.trim() === '') {
      throw new Error('Product slug is required');
    }

    const product = await this.productService.getProductBySlug(input.slug);

    return {
      product,
    };
  }
}

